import "./main.css";
import { Elm } from "./Main.elm";
import * as serviceWorker from "./serviceWorker";

const app = Elm.Main.init({
  node: document.getElementById("root")
});

// Scrolling Logic for the dynamic header:

var _window = window;
var _document = _window.document;
var _body = _document.body;
var _html = _document.documentElement;

var scrollTimer = null;
var lastScrollFireTime = 0;
var minScrollTime = 200;

function scrollOrResize(event) {
  event.returnValue = false;

  if (scrollTimer) {
  } else {
    var now = new Date().getTime();
    if (now - lastScrollFireTime > 3 * minScrollTime) {
      processScrollOrResize();
      lastScrollFireTime = now;
    }
    scrollTimer = setTimeout(function () {
      scrollTimer = null;
      lastScrollFireTime = new Date().getTime();
      processScrollOrResize();
    }, minScrollTime);
  }
}

document.body.onscroll = scrollOrResize;
document.body.onresize = scrollOrResize;

var processScrollOrResize = function () {
  var screenData = {
    scrollTop: parseInt(
      window.pageYOffset || _html.scrollTop || _body.scrollTop || 0
    ),
    pageHeight: parseInt(
      Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        _html.clientHeight,
        _html.scrollHeight,
        _html.offsetHeight
      )
    ),
    viewportHeight: parseInt(_html.clientHeight),
    viewportWidth: parseInt(_html.clientWidth),
  };

  var Viewport = {
    scene: {
      height: screenData.pageHeight,
      width: screenData.viewportWidth,
    },
    viewport: {
      height: screenData.viewportHeight,
      width: screenData.viewportWidth,
      x: 0,
      y: screenData.scrollTop,
    },
  };

  app.ports.messageReceiver.send(Viewport);
};

// Disable right click on all images
document.addEventListener("contextmenu", function (event) {
  if (event.target.tagName === "IMG") {
    event.preventDefault();
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
